import React from 'react';
import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import {
  CardComponent,
  NavigationArrow,
  PageTitleAndSubTitle,
  TextField,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import experienceConstants from '../../../core-utils/messages/experienceConstants';
import {
  CheckBox,
  patientAccessTheme,
  Typography,
} from '@HomaHealth/ui-component-library';
import { SimpleSearch } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import roverTheme, {
  employeeTheme,
} from '@HomaHealth/ui-component-library/lib/theme/theme';
import { useNavigate } from 'react-router-dom';

const useStyles = makeStyles()(() => ({
  mainDiv: {
    padding: '40px 64px 24px 64px',
  },
  pageHeader: {
    display: 'flex',
    gap: '10px',
    padding: '40px 64px 24px 64px',
    alignItems: 'center',
  },
  hr: {
    width: '100%',
    border: `1px solid ${patientAccessTheme.palette.grey[300]}`,
    margin: '18px 0px',
  },
  navigationArrow: {
    rotate: '180deg',
    cursor: 'pointer',
    top: '30px',
    marginBottom: '10px',
  },
  menuContainer: {
    width: 247,
    display: 'flex',
    flexDirection: 'column',
    rowGap: 8,
  },
  menuItem: {
    height: 38,
    padding: '8px 12px',
    borderRadius: 4,
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#EEF3F7',
    },
  },
  selected: {
    backgroundColor: `${employeeTheme.palette.grey[100]}`,
    '&:hover': {
      backgroundColor: `${employeeTheme.palette.grey[100]}`,
    },
  },
  categoriesSection: {
    width: '24%',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  mainBodySection: {
    width: '70%',
  },
  cardTitle: {
    padding: '16px 24px',
    backgroundColor: `${roverTheme.palette.grey[300]}`,
    boxSizing: 'border-box',
  },
}));

const categories = [
  'Claims AIQ',
  'Contract AIQ',
  'News',
  'Operations',
  'Risks',
  'Regulations',
];

const CustomizeNotification: React.FC = () => {
  const { classes } = useStyles();
  const navigate = useNavigate();
  const message = experienceConstants;
  const [selected, setSelected] = React.useState(categories[0]);

  const diseaseData = [
    {
      title: 'Disease Prevalence',
      items: [
        {
          name: 'Blood Disorders',
          prevalenceRate: '>20%',
          avgCost: '>$1200',
          parameters: 2,
          selected: false,
        },
        {
          name: 'Psychological',
          prevalenceRate: '>20%',
          avgCost: '>$1200',
          parameters: 2,
          selected: false,
        },
      ],
    },
    {
      title: 'Rising Risk',
      items: [
        {
          name: 'Acute Myocardial Infarction',
          prevalenceRate: '>20%',
          avgCost: '>$1200',
          parameters: 2,
          selected: true,
        },
        {
          name: 'Alzheimer Disease',
          prevalenceRate: '>20%',
          avgCost: '>$1200',
          parameters: 2,
          selected: true,
        },
        {
          name: 'Atrial Fibrillation',
          prevalenceRate: '>20%',
          avgCost: '>$1200',
          parameters: 2,
          selected: true,
        },
        {
          name: 'Benign Prostatic Hyperplasia',
          prevalenceRate: '>20%',
          avgCost: '>$1200',
          parameters: 2,
          selected: true,
        },
        {
          name: 'Chronic Kidney Disease',
          prevalenceRate: '>20%',
          avgCost: '>$1200',
          parameters: 2,
          selected: true,
        },
      ],
    },
  ];

  return (
    <>
      <Grid className={classes.pageHeader}>
        <NavigationArrow
          className={classes.navigationArrow}
          // onClick={() => history.push(location?.previousRoute)}
        />
        <PageTitleAndSubTitle
          title={message.TITLES.CUSTNOTITITLE}
          subTitle=""
          customButton={true}
          customButtonText={['Cancel', 'Save Actions']}
          customButtonVariant={['text', 'contained']}
          customButtonClick={[
            () => {},
            () => {
              navigate('/customize-notification');
            },
          ]}
          customButtonWidth={['86px', 'auto']}
        />
      </Grid>
      <hr className={classes.hr} />
      <Grid className={classes.mainDiv}>
        <CardComponent
          title=""
          body={
            <Grid container>
              <Grid className={classes.categoriesSection}>
                <Typography
                  fontSize="12px"
                  textColor={patientAccessTheme.palette.text.mediumemphasis}
                >
                  Categories
                </Typography>
                <Grid className={classes.menuContainer}>
                  {categories.map((label) => (
                    <Grid
                      key={label}
                      className={`${classes.menuItem} ${
                        selected === label ? classes.selected : ''
                      }`}
                      onClick={() => setSelected(label)}
                    >
                      <Typography
                        fontSize="14px"
                        fontType="medium"
                        textColor={
                          selected === label
                            ? patientAccessTheme.palette.text.highemphasis
                            : patientAccessTheme.palette.text.mediumemphasis
                        }
                      >
                        {label}
                      </Typography>
                    </Grid>
                  ))}
                </Grid>
              </Grid>
              <Grid className={classes.mainBodySection}>
                <TextField
                  placeholder={'Search Standards'}
                  height="40px"
                  width="324px"
                  endAdornment={
                    <SimpleSearch
                      height="20px"
                      width="20px"
                      stroke={patientAccessTheme.palette.text.lowemphasis}
                    />
                  }
                  // value={searchText}
                  // onChange={handleChange}
                  inputPropsStyle={{ margin: '1rem 0' }}
                />
                {/* <CardComponent
                  mainGridStyles={{
                    padding: '0px',
                  }}
                  title={''}
                  body={
                    <Grid>
                      <Typography
                        style={{
                          backgroundColor: '#F5F8FA',
                        }}
                      >
                        Test 1
                      </Typography>
                    </Grid>
                  }
                /> */}
                <CardComponent
                  // title={''}
                  title={
                    <Grid className={classes.cardTitle}>
                      <Typography fontSize="14px" fontType="medium">
                        {selected}
                      </Typography>
                    </Grid>
                  }
                  mainGridStyles={{
                    padding: '0px',
                    width: '100%',
                  }}
                  body={
                    <>
                      {/* <Grid className={classes.cardTitle}>
                        <Typography fontSize="14px" fontType="medium">
                          {selected}
                        </Typography>
                      </Grid> */}
                      <Grid
                        container
                        spacing={3}
                        sx={{
                          flexDirection: 'column',
                        }}
                      >
                        {diseaseData.map((section, sectionIndex) => (
                          <Grid
                            key={sectionIndex}
                            style={{
                              padding: '8px 24px',
                              borderTop: '1px solid #E5E9F0',
                              borderBottom: '1px solid #E5E9F0',
                            }}
                          >
                            <Typography fontType="medium" fontSize="12px">
                              {section.title}
                            </Typography>

                            {section.items.map((item, itemIndex) => (
                              <Grid
                                container
                                key={itemIndex}
                                spacing={2}
                                sx={{
                                  alignItems: 'center',
                                  justifyContent: 'space-between',
                                }}
                              >
                                <Grid size={3}>
                                  <Typography
                                    fontSize="12px"
                                    fontType="medium"
                                    textColor={
                                      patientAccessTheme.palette.text
                                        .mediumemphasis
                                    }
                                  >
                                    {item.name}
                                  </Typography>
                                </Grid>
                                <Grid size={3}>
                                  <Typography
                                    fontSize="12px"
                                    fontType="medium"
                                    textColor={
                                      patientAccessTheme.palette.text
                                        .mediumemphasis
                                    }
                                  >
                                    Prevalence rate {item.prevalenceRate}
                                  </Typography>
                                </Grid>
                                <Grid size={3}>
                                  <Typography
                                    fontSize="12px"
                                    fontType="medium"
                                    textColor={
                                      patientAccessTheme.palette.text
                                        .mediumemphasis
                                    }
                                  >
                                    Avg Cost {item.avgCost}
                                  </Typography>
                                </Grid>
                                <Grid size={2}>
                                  <Typography
                                    fontSize="12px"
                                    fontType="medium"
                                    textColor={
                                      patientAccessTheme.palette.text
                                        .mediumemphasis
                                    }
                                  >
                                    +{item.parameters} Parameters
                                  </Typography>
                                </Grid>
                                <Grid size={1}>
                                  <CheckBox
                                    checked={item.selected}
                                    id=""
                                    name=""
                                    color="primary"
                                  />
                                </Grid>
                              </Grid>
                            ))}
                          </Grid>
                        ))}
                      </Grid>
                    </>
                  }
                />
              </Grid>
            </Grid>
          }
        />
      </Grid>
    </>
  );
};

export default CustomizeNotification;
